import { Typography } from '@sravni/react-design-system';
import type { TextProps } from '@sravni/react-design-system/dist/types/components/Typography/types/Text.types';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import type { FC } from 'react';

import styles from './AdaptiveText.module.scss';

interface IAdoptiveTitleTextProp {
  className?: string;
  strong?: boolean;
  nowrap?: boolean;
  range?: [TextProps['size'], TextProps['size']];
}

const DEFAULT_RANGE: [TextProps['size'], TextProps['size']] = [14, 16];
export const AdaptiveTitleText: FC<IAdoptiveTitleTextProp> = ({
  range = DEFAULT_RANGE,
  strong = true,
  children,
  className,
  nowrap,
}) => {
  const isMobile = useIsMobile();

  return (
    <Typography.Text
      nowrap={nowrap}
      strong={strong}
      size={isMobile ? range[0] : range[1]}
      className={cn(styles.adaptiveText, className)}
    >
      {children}
    </Typography.Text>
  );
};
